import { Injectable } from "@angular/core";
import { SHOPIFY_ORDER_QUERY } from "../constant/shopify-order-query.constant";
import { ShopifyOrderResponse } from "../models/shopify-order-query-response";
import { appConfig } from "../constant/app.constant";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: "root" })

export class ExternalIntegrationsService {

    private _url = `${appConfig.BASE_URL}returnorders`;

    shopifyOrderDetails: ShopifyOrderResponse;

    constructor(private httpClient: HttpClient) { }

    searchShopifyOrder(orderNo: string, email: string, merchantId: string) {
        const queryString = SHOPIFY_ORDER_QUERY.replace('{orderNo}', orderNo).replace('{email}', email);

        const queryPayload = {
            merchantId: merchantId,
            queryParams: {
                query: queryString
            }
        };

        return this.httpClient.post<ShopifyOrderResponse>(`${this._url}/GetShopifyOrder`, queryPayload);
    }
}
